module.exports = __webpack_public_path__ + "static/media/splash-image.e5fe501a.png";